module.exports = __webpack_public_path__ + "static/media/FielPetLogo.5820d564.png";